import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterFormList',
})
export class FilterFormList implements PipeTransform {
  transform(list: any[], searchText: string): any[] {
    if (!list) {
      return [];
    }

    if (!searchText) {
      return list;
    }

    searchText = searchText.toLocaleLowerCase();

    let filteredList = list.filter((item) => {
      if (item?.type_template?.toLocaleLowerCase().includes(searchText) || item?.type?.toLocaleLowerCase().includes(searchText)) {
        return item;
      }
    });

    return filteredList;
  }
}
